import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconNoteSvg } from "./IconNoteSvg.mjs";
const IconNote = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconNoteSvg, ...svgProps }) });
export {
  IconNote
};
